const currencyMapping = {
	GBP: {
		value: "£",
		isMajor: true
	},
	GBX: {
		value: "p",
		isMajor: false
	},
	EUR: {
		value: "€",
		isMajor: true
	},
	USD: {
		value: "$",
		isMajor: true
	},
	CHF: {
		value: "CHF",
		isMajor: true
	},
	SGD: {
		value: "SGD",
		isMajor: true
	}
}

export function getCurrencySymbol(currencyCode: string): {value:string, isMajor: boolean} {
	if (currencyMapping[currencyCode]) {
		return currencyMapping[currencyCode];
	}

	return null;
}


// WEBPACK FOOTER //
// ./src/client/utils/currency.ts